export default (selectedIds) => ({
    list: false,
    restUrl: '',
    loading: true,
    payload: {
        ids: [],
        page: 1,
    },

    init() {
        this.restUrl = window?.ajax_object?.restUrlSelectedCars ?? '';
        this.payload.ids = selectedIds ?? [];
        this.fetchSelectedCars();
    },

    paginateTo(page) {
        this.payload.page = page;
        this.fetchSelectedCars();
    },

    fetchSelectedCars() {
        this.loading = true;

        fetch(this.restUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.payload),
        })
          .then(response => response.text())
          .then((data) => {
                document.querySelector('[data-search-car-results]').innerHTML = data;
                if (window.hasOwnProperty('skodaLazyLoad')) {
                    window.skodaLazyLoad.update();
                }
            })
            .catch((error) => {
                console.error('Uhmm...', error);
            })
            .finally(() => {
                this.loading = false;
            })
    },
});
